import React from 'react';
import WordListContext from './WordListContext';
import {FeedbackTriggerType} from 'records/FeedbackTrigger';
import withRecipients from 'components/triggers/rule-context/WithRecipients';
import {SmartAlertContextTitle} from 'components/triggers/rule-context/SmartAlertContextTitle';
import {HighlightIcon} from '@components/icon/HighlightIcon';

class HighlightContext extends React.Component {
  constructor(props) {
    super(props);

    this.getHighlights = this.getHighlights.bind(this);
    this.getHighlightsIndex = this.getHighlightsIndex.bind(this);

    this.highlightsChange = this.highlightsChange.bind(this);
    this.state = {userContextSelected: false};
  }

  getHighlights() {
    return this.props.context.matchAll.find(item => item.type === FeedbackTriggerType.HIGHLIGHT);
  }

  getHighlightsIndex() {
    const highlights = this.getHighlights();
    return this.props.context.matchAll.indexOf(highlights);
  }

  highlightsChange(highlightsContext) {
    const highlightIndex = this.getHighlightsIndex();
    const newContext = this.props.context.setIn(['matchAll', highlightIndex], highlightsContext);
    this.props.contextChange(newContext);
  }

  render() {
    // XXX EV-13652 review function to remove get recipients
    const {usersEmpty, renderEmbeddedContent, showContextButton} = this.props;
    const commentList = this.getHighlights();
    const highlightsEmpty = commentList.matching.size === 0;
    const narrow = highlightsEmpty && usersEmpty;
    return (
      <div className="context-container">
        <SmartAlertContextTitle icon={HighlightIcon} onClose={this.props.removeContext}>
          <span>they left a highlight</span>
        </SmartAlertContextTitle>
        <div className={narrow && 'initial-options'}>
          {renderEmbeddedContent()}
          {showContextButton && (
            <WordListContext
              context={commentList}
              label={'Optional: Specify highlight keywords'}
              contextChange={this.highlightsChange}
            />
          )}
        </div>
      </div>
    );
  }
}

export default withRecipients(HighlightContext);
